import Translater from './translater';

export default Translater;